import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'section-link',
  templateUrl: './section-link.component.html',
  styleUrls: ['./section-link.component.scss']
})
export class SectionLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input()
  href : string;

  private _active : string;

  get active() : string {
    return this._active;
  }
  
  @Input()
  set active(value : string) {
    this._active = value;
    this.activeChange.next(value);
  }

  @Output()
  activeChange : EventEmitter<string> = new EventEmitter<string>();

  @Input()
  name : string;

  get isActive() {
    return this.active == this.name;
  }

}
